import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { useAuthor } from '@/hooks/useAuthor';
import { Megaphone, ExternalLink } from 'lucide-react';
import { genUserName } from '@/lib/genUserName';

const VIDEO_URL = 'https://blossom.primal.net/5d7c58eb52d98e07b074f6b6c653ff5f4be729acc0e88b9b296485105f1f2078.mp4';

/** Noa Gruman's pubkey */
const NOA_GRUMAN_PUBKEY = '6838a529bdf33d2569e3708df6373572f11b378114d225a4d467a9bd94abef2a';
const NOA_GRUMAN_NPUB = 'npub1dqu222da7v7j260rwzxlvde4wtc3kdupznfztfx5v75mm99tau4qrsp94g';

export function AnnouncementVideo() {
  const author = useAuthor(NOA_GRUMAN_PUBKEY);
  const metadata = author.data?.metadata;
  const displayName = metadata?.display_name || metadata?.name || genUserName(NOA_GRUMAN_PUBKEY);
  const picture = metadata?.picture;

  return (
    <section className="relative py-12 sm:py-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 space-y-2">
          <Badge className="bg-primary/10 text-primary border border-primary/20 text-xs px-3 py-1 tracking-wider uppercase font-medium">
            <Megaphone className="w-3 h-3 mr-1.5" />
            Launch Reveal
          </Badge>
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-foreground">
            Watch the <span className="text-bitcoin-gradient">Reveal</span>
          </h2>
        </div>

        <Card className="overflow-hidden border-border/30 bg-card/60 backdrop-blur-sm">
          <CardContent className="p-0">
            <video
              src={VIDEO_URL}
              controls
              preload="metadata"
              className="w-full aspect-video"
            >
              Your browser does not support the video element.
            </video>

            {/* Credit bar */}
            <div className="px-5 py-4 border-t border-border/30 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <span className="text-xs text-muted-foreground uppercase tracking-wider">Featuring</span>
                <a
                  href={`https://ditto.pub/${NOA_GRUMAN_NPUB}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 group"
                >
                  <Avatar className="w-7 h-7">
                    {picture && <AvatarImage src={picture} alt={displayName} />}
                    <AvatarFallback className="text-xs bg-primary/10 text-primary">
                      {displayName.charAt(0)}
                    </AvatarFallback>
                  </Avatar>
                  <span className="text-sm font-medium text-foreground/90 group-hover:text-primary transition-colors">
                    {displayName}
                  </span>
                  <ExternalLink className="w-3 h-3 text-muted-foreground group-hover:text-primary transition-colors" />
                </a>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
}
